<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'NewsCenter', to: { path: '/news-center' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>NewsCenter</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toNewsCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增文章</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <NewsCenterTable></NewsCenterTable>
    </div>
    <!-- NewsCenter PageTitle -->
    <div class="page-actions">
      <h2>NewsCenter PageTitle</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toEditNewscenterPageTitle">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>
    <div class="block" v-if="pageTitle != null">
      <!-- PageTitle -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ pageTitle.title }}
        </div>
      </div>
      <!-- Background -->
      <div class="form-item py-5 d-flex" v-if="false">
        <div class="w-94px mr-166px">
          <h4>Background</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center"
            :style="{
              width: '480px',
              height: '76px',
              'background-image': `url(${pageTitle.image||background})`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import NewsCenterTable from '@/views/E-4__News/c/NewsCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    NewsCenterTable,
  },
  created() {
    this.clear();
    this.getNewsList();
    this.getPageTitle('news');
  },
  computed: {
    ...mapState('pageTitle', ['pageTitle']),
  },
  methods: {
    ...mapActions('pageTitle', {
      getPageTitle: 'findByType',
    }),
    ...mapActions('news', {
      getNewsList: 'find',
      clear: 'clear',
    }),
    toNewsCreate() {
      this.$router.push('/news-center/create');
    },
    toEditNewscenterPageTitle() {
      this.$router.push('/news-center/edit-newscenter-page-title');
    },
  },
};
</script>

<style></style>
